var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "visible-condition-editor"
  }, _vm._l(_vm.conditionList, function (condition, conditionIndex) {
    return _c('b-input-group', {
      key: conditionIndex,
      staticClass: "visible-condition-editor__condition"
    }, [_c('b-input-group-prepend', [_c('span', {
      staticClass: "mdi mdi-lightbulb-on-outline option-drag-handler"
    })]), _c('div', {
      staticClass: "visible-condition-editor__advance-option-content-wrapper"
    }, [_c('span', [_vm._v(_vm._s(conditionIndex > 0 ? '或當' : '當'))]), _c('b-form-select', {
      staticStyle: {
        "max-width": "200px"
      },
      attrs: {
        "options": _vm.visibleConditionFieldCandidates
      },
      on: {
        "input": function input($event) {
          return _vm.handleVisibleConditionFieldChanges(conditionIndex);
        }
      },
      model: {
        value: condition.field_id,
        callback: function callback($$v) {
          _vm.$set(condition, "field_id", $$v);
        },
        expression: "condition.field_id"
      }
    }), _c('span', [_vm._v("為")]), _c('b-form-select', {
      staticStyle: {
        "max-width": "200px"
      },
      attrs: {
        "options": _vm.visibleConditionValueCandidates(conditionIndex)
      },
      on: {
        "input": _vm.handleVisibleConditionOptionChanges
      },
      model: {
        value: condition.value,
        callback: function callback($$v) {
          _vm.$set(condition, "value", $$v);
        },
        expression: "condition.value"
      }
    }), _c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center text-nowrap",
      attrs: {
        "variant": "inverse-success"
      },
      on: {
        "click": function click($event) {
          return _vm.createCondition(conditionIndex + 1);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-plus"
    }), _vm._v(" 增加 ")]), _c('b-button', {
      staticClass: "ml-2 p-1 d-inline-flex align-items-center text-nowrap",
      attrs: {
        "variant": "inverse-danger"
      },
      on: {
        "click": function click($event) {
          return _vm.removeCondition(conditionIndex);
        }
      }
    }, [_c('span', {
      staticClass: "mdi mdi-18px mdi-playlist-remove"
    }), _vm._v(" 移除 ")])], 1)], 1);
  }), 1);
}
var staticRenderFns = []

export { render, staticRenderFns }